import _ from "lodash";

export const hotelsSampleData = [
    {
        "aaHotelId": "8d73",
        "property_type": {
            "id": 2,
            "name": "Hotel"
        },
        "address": {
            "city": "Kuala Lumpur",
            "country": "Malaysia",
            "country_code": "MY",
            "line_1": "30, Jalan Beremi,",
            "line_2": "Off Jalan Sultan Ismail",
            "postal_code": "50200",
            "state_province_name": ""
        },
        "amenities": {
            "other_amenities": [],
            "top_amenities": [
                {
                    "id": 17,
                    "name": "24-hour front desk"
                },
                {
                    "id": 19,
                    "name": "Luggage storage"
                },
                {
                    "id": 3,
                    "name": "Gym"
                },
                {
                    "id": 18,
                    "name": "Dry cleaning/laundry service"
                },
                {
                    "id": 1,
                    "name": "Free Wifi"
                },
                {
                    "id": 8,
                    "name": "Smoke-free property"
                }
            ]
        },
        "description": {
            "amenities": "Be sure to enjoy recreational amenities including an outdoor pool and a fitness center.",
            "attractions": "Distances are displayed to the nearest 0.1 mile and kilometer. <br /> <p>Changkat Bukit Bintang - 0.2 km / 0.1 mi <br /> Lot 10 Shopping Centre - 0.3 km / 0.2 mi <br /> Fahrenheit 88 Shopping Mall - 0.4 km / 0.2 mi <br /> Bukit Bintang Plaza - 0.4 km / 0.2 mi <br /> Jalan Alor - 0.4 km / 0.2 mi <br /> Sungei Wang Plaza - 0.4 km / 0.3 mi <br /> Low Yat Plaza - 0.5 km / 0.3 mi <br /> Starhill Gallery - 0.5 km / 0.3 mi <br /> Pavilion Kuala Lumpur - 0.6 km / 0.4 mi <br /> Berjaya Times Square - 0.7 km / 0.5 mi <br /> Kuala Lumpur Convention Centre - 1 km / 0.6 mi <br /> KLCC Park - 1 km / 0.6 mi <br /> Kuala Lumpur Forest Eco Park - 1 km / 0.6 mi <br /> Mitsui Shopping Park LaLaport - 1.2 km / 0.7 mi <br /> Kuala Lumpur Tower - 1.4 km / 0.9 mi <br /> </p><p>The nearest airports are:<br />Kuala Lumpur International Airport (KUL) - 58.9 km / 36.6 mi<br /> Subang (SZB-Sultan Abdul Aziz Shah) - 30.2 km / 18.8 mi<br /> </p><p>The preferred airport for The Kuala Lumpur Journal is Kuala Lumpur International Airport (KUL). </p>",
            "business_amenities": "Featured amenities include dry cleaning/laundry services, a 24-hour front desk, and multilingual staff. This hotel has 3 meeting rooms available for events. Limited parking is available onsite.",
            "dining": "Enjoy a satisfying meal at Journal Coffee Bar serving guests of The Kuala Lumpur Journal. Relax with your favorite drink at the bar/lounge or the poolside bar. Buffet breakfasts are available daily from 7:30 AM to 10:30 AM for a fee.",
            "location": "The Kuala Lumpur Journal is centrally located in Kuala Lumpur, a 5-minute walk from Jalan Alor and 7 minutes by foot from Pavilion Kuala Lumpur.  This 4-star hotel is 1.1 mi (1.8 km) from Kuala Lumpur Forest Eco Park and 1.1 mi (1.8 km) from Kuala Lumpur Tower.",
            "rooms": "Make yourself at home in one of the 121 air-conditioned rooms featuring free minibar items and Smart televisions. Complimentary wireless Internet access keeps you connected, and satellite programming is available for your entertainment. Private bathrooms with showers feature rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as laptop-compatible safes and desks."
        },
        "gallery": {
            "images": [
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Dining4.JPG",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Dining4.JPG",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Dining4.JPG"
                    },
                    "id": "IP13183369DS:8"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Dining5.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Dining5.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Dining5.jpg"
                    },
                    "id": "IP13183369DS:9"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Aerial2.JPG",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Aerial2.JPG",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Aerial2.JPG"
                    },
                    "id": "IP13183369DS:2"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Amenities1.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Amenities1.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Amenities1.jpg"
                    },
                    "id": "IP13183369DS:10"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Reception1.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Reception1.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Reception1.jpg"
                    },
                    "id": "IP13183369DS:3"
                },
                {
                    "hero_image": true,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Hero.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Hero.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Hero.jpg"
                    },
                    "id": "IP13183369DS:0"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Aerial1.JPG",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Aerial1.JPG",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Aerial1.JPG"
                    },
                    "id": "IP13183369DS:1"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Dining2.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Dining2.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Dining2.jpg"
                    },
                    "id": "IP13183369DS:6"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Dining3.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Dining3.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Dining3.jpg"
                    },
                    "id": "IP13183369DS:7"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Reception2.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Reception2.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Reception2.jpg"
                    },
                    "id": "IP13183369DS:4"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Dining1.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Dining1.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Dining1.jpg"
                    },
                    "id": "IP13183369DS:5"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Room3.JPG",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Room3.JPG",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Room3.JPG"
                    },
                    "id": "IP13183369DS:16"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Room2.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Room2.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Room2.jpg"
                    },
                    "id": "IP13183369DS:15"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Room1.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Room1.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Room1.jpg"
                    },
                    "id": "IP13183369DS:14"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Amenities4.JPG",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Amenities4.JPG",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Amenities4.JPG"
                    },
                    "id": "IP13183369DS:13"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Amenities3.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Amenities3.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Amenities3.jpg"
                    },
                    "id": "IP13183369DS:12"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-70/13183369/Amenities2.jpg",
                        "350px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Amenities2.jpg",
                        "1000px": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-1000/13183369/Amenities2.jpg"
                    },
                    "id": "IP13183369DS:11"
                }
            ]
        },
        "guest_rating": {
            "rating": "4.4",
            "count": 993,
            "cleanliness": "4.4",
            "service": "4.4",
            "comfort": "4.4",
            "condition": "4.3",
            "location": "4.8",
            "neighbourhood": "4.6",
            "amenities": "4.3"
        },
        "location": {
            "coordinates": {
                "latitude": 3.148078,
                "longitude": 101.710445
            }
        },
        "name": "The Kuala Lumpur Journal",
        "star_rating": {
            "rating": "4.0",
            "type": "Star"
        },
        "checkin_details": {
            "time": "2:00 PM",
            "instructions": "<ul>  <li>Extra-person charges may apply and vary depending on property policy</li><li>Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges</li><li>Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed</li><li>Safety features at this property include a fire extinguisher and a smoke detector</li><li>Be prepared: check the latest COVID-19 travel requirements and measures in place for this destination before you travel.</li>  </ul>",
            "special_instructions": "Front desk staff will greet guests on arrival. At check-in, guests must provide a record of full COVID-19 vaccination."
        },
        "checkout_details": {
            "time": "正午"
        },
        "policies": {
            "know_before_you_go": "<ul>   <li>One child 12 years old or younger stays free when occupying the parent or guardian's room, using existing bedding. </li><li>Parking height restrictions apply. </li><li>This property advises that enhanced cleaning and guest safety measures are currently in place.</li><li>Disinfectant is used to clean the property; commonly-touched surfaces are cleaned with disinfectant between stays; bed sheets and towels are laundered at a temperature of at least 60°C/140°F.</li><li>Social distancing measures are in place; staff at the property wear personal protective equipment; periodic temperature checks are conducted on staff; temperature checks are available to guests; guests are provided with hand sanitizer; masks are required in public areas; reservations are required for some onsite facilities.</li><li>Enhanced food service safety measures are in place.</li><li>Individually-wrapped food options are available through room service.</li><li>At check-in, guests must provide a record of full COVID-19 vaccination.</li><li>This property affirms that it follows the cleaning and disinfection practices of Safe & Clean (Malaysia).</li><li>This property affirms that it adheres to the cleaning and disinfection practices of Safe Travels (WTTC - Global), COVID-19 Guidelines (WHO), and COVID-19 Guidelines (CDC).</li>\n </ul>",
            "age_policy": {
                "min_adult_age": 13,
                "children_age_from": 4,
                "children_age_to": 12,
                "children_stay_free": false,
                "min_guest_age": 0
            }
        },
        "fees": {
            "mandatory": "",
            "optional": ""
        },
        "spoken_languages": [
            {
                "id": 37,
                "name": "Malay"
            },
            {
                "id": 13,
                "name": "English"
            }
        ],
        "tax_id": "",
        "registration_number": "",
        "phone": "60-3-21102211",
        "fax": "60-3-21101100",
        "brand": {
            "id": 5696,
            "name": "Independent"
        },
        "chain": {
            "id": 5275,
            "name": "Independent"
        },
        "airports": {
            "nearest_airport": "KUL"
        },
        "headline": "Near Pavilion Kuala Lumpur",
        "timezone": "Asia/Kuala_Lumpur",
        "need_nationality": false,
        "default_locale_used": false,
        "nearbyPoi": [
            {
                "name": "Changkat Bukit Bintang",
                "distance": "0.2 km / 0.1 mi"
            },
            {
                "name": "Lot 10 Shopping Centre",
                "distance": "0.3 km / 0.2 mi"
            },
            {
                "name": "Fahrenheit 88 Shopping Mall",
                "distance": "0.4 km / 0.2 mi"
            },
            {
                "name": "Bukit Bintang Plaza",
                "distance": "0.4 km / 0.2 mi"
            },
            {
                "name": "Jalan Alor",
                "distance": "0.4 km / 0.2 mi"
            },
            {
                "name": "Sungei Wang Plaza",
                "distance": "0.4 km / 0.3 mi"
            },
            {
                "name": "Low Yat Plaza",
                "distance": "0.5 km / 0.3 mi"
            },
            {
                "name": "Starhill Gallery",
                "distance": "0.5 km / 0.3 mi"
            },
            {
                "name": "Pavilion Kuala Lumpur",
                "distance": "0.6 km / 0.4 mi"
            },
            {
                "name": "Berjaya Times Square",
                "distance": "0.7 km / 0.5 mi"
            },
            {
                "name": "Kuala Lumpur Convention Centre",
                "distance": "1 km / 0.6 mi"
            },
            {
                "name": "KLCC Park",
                "distance": "1 km / 0.6 mi"
            },
            {
                "name": "Kuala Lumpur Forest Eco Park",
                "distance": "1 km / 0.6 mi"
            },
            {
                "name": "Mitsui Shopping Park LaLaport",
                "distance": "1.2 km / 0.7 mi"
            },
            {
                "name": "Kuala Lumpur Tower",
                "distance": "1.4 km / 0.9 mi"
            }
        ],
        "debug": {
            "aaid": "8d73"
        }
    },
    {
        "aaHotelId": "9868",
        "property_type": {
            "id": 2,
            "name": "Hotel"
        },
        "address": {
            "city": "Kuala Lumpur",
            "country": "Malaysia",
            "country_code": "MY",
            "line_1": "No. 66 & 68, Jalan Sultan",
            "line_2": "",
            "postal_code": "50000",
            "state_province_name": ""
        },
        "amenities": {
            "other_amenities": [],
            "top_amenities": [
                {
                    "id": 17,
                    "name": "24-hour front desk"
                },
                {
                    "id": 19,
                    "name": "Luggage storage"
                },
                {
                    "id": 1,
                    "name": "Free Wifi"
                },
                {
                    "id": 8,
                    "name": "Smoke-free property"
                }
            ]
        },
        "description": {
            "amenities": "This smoke-free hotel was built in 2017.",
            "attractions": "Distances are displayed to the nearest 0.1 mile and kilometer. <br /> <p>Petaling Street - 0.2 km / 0.1 mi <br /> Petaling Street Market - 0.2 km / 0.1 mi <br /> Central Market - 0.5 km / 0.3 mi <br /> Merdeka 118 - 0.5 km / 0.3 mi <br /> Kottu Malai Pillayar Temple - 0.6 km / 0.3 mi <br /> Jamek Mosque - 0.7 km / 0.4 mi <br /> Kuala Lumpur Forest Eco Park - 0.9 km / 0.5 mi <br /> Merdeka Square - 1 km / 0.6 mi <br /> DBKL City Theatre - 1 km / 0.6 mi <br /> Masjid India - 1.1 km / 0.7 mi <br /> Mitsui Shopping Park LaLaport - 1.2 km / 0.8 mi <br /> Kuala Lumpur Tower - 1.4 km / 0.9 mi <br /> Jalan Alor - 1.4 km / 0.9 mi <br /> Low Yat Plaza - 1.5 km / 1 mi <br /> Changkat Bukit Bintang - 1.5 km / 1 mi <br /> </p><p>The nearest airports are:<br />Kuala Lumpur International Airport (KUL) - 57.3 km / 35.6 mi<br /> Subang (SZB-Sultan Abdul Aziz Shah) - 21.8 km / 13.5 mi<br /> </p><p>The preferred airport for Tian Jing Hotel is Kuala Lumpur International Airport (KUL). </p>",
            "business_amenities": "Featured amenities include a 24-hour front desk and luggage storage.",
            "dining": "Enjoy a meal at Lim Kee Cafe or snacks in the hotel's coffee shop/cafe. Local cuisine breakfasts are available daily from 8:30 AM to 10:30 AM for a fee.",
            "location": "With a stay at Tian Jing Hotel, you'll be centrally located in Kuala Lumpur, within a 10-minute drive of Berjaya Times Square and Pavilion Kuala Lumpur.  This hotel is 2.4 mi (3.8 km) from Suria KLCC Shopping Centre and 2.4 mi (3.9 km) from KLCC Park.",
            "rooms": "Make yourself at home in one of the 15 air-conditioned rooms featuring LED televisions. Complimentary wireless Internet access keeps you connected, and satellite programming is available for your entertainment. Private bathrooms with showers feature complimentary toiletries and bidets. Conveniences include safes and electric kettles, and housekeeping is provided on request."
        },
        "gallery": {
            "images": [
                {
                    "hero_image": false,
                    "category": {
                        "id": 186,
                        "name": "Hallway"
                    },
                    "caption": "Hallway",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/bca4d1c9_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/bca4d1c9_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/bca4d1c9_z.jpg"
                    },
                    "id": "19904258:70"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 187,
                        "name": "Staircase"
                    },
                    "caption": "Staircase",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fc384077_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fc384077_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fc384077_z.jpg"
                    },
                    "id": "19904258:72"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 186,
                        "name": "Hallway"
                    },
                    "caption": "Hallway",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b788fc6f_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b788fc6f_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b788fc6f_z.jpg"
                    },
                    "id": "19904258:71"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/68ae7b02_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/68ae7b02_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/68ae7b02_z.jpg"
                    },
                    "id": "19904258:30"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 190,
                        "name": "Interior Detail"
                    },
                    "caption": "Interior detail",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c7257581_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c7257581_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c7257581_z.jpg"
                    },
                    "id": "19904258:74"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 187,
                        "name": "Staircase"
                    },
                    "caption": "Staircase",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cc1e9339_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cc1e9339_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cc1e9339_z.jpg"
                    },
                    "id": "19904258:73"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/8e1e08af_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/8e1e08af_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/8e1e08af_z.jpg"
                    },
                    "id": "19904258:32"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 190,
                        "name": "Interior Detail"
                    },
                    "caption": "Interior detail",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42fa2f29_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42fa2f29_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42fa2f29_z.jpg"
                    },
                    "id": "19904258:76"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3bd6c2cb_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3bd6c2cb_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3bd6c2cb_z.jpg"
                    },
                    "id": "19904258:31"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 190,
                        "name": "Interior Detail"
                    },
                    "caption": "Interior detail",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c88a27ab_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c88a27ab_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c88a27ab_z.jpg"
                    },
                    "id": "19904258:75"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fb1e2d98_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fb1e2d98_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fb1e2d98_z.jpg"
                    },
                    "id": "19904258:34"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 190,
                        "name": "Interior Detail"
                    },
                    "caption": "Interior detail",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1492d870_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1492d870_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1492d870_z.jpg"
                    },
                    "id": "19904258:78"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/46f17361_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/46f17361_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/46f17361_z.jpg"
                    },
                    "id": "19904258:33"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 190,
                        "name": "Interior Detail"
                    },
                    "caption": "Interior detail",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c02a78e6_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c02a78e6_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c02a78e6_z.jpg"
                    },
                    "id": "19904258:77"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42ef9e9f_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42ef9e9f_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42ef9e9f_z.jpg"
                    },
                    "id": "19904258:36"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1333fea7_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1333fea7_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1333fea7_z.jpg"
                    },
                    "id": "19904258:35"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 190,
                        "name": "Interior Detail"
                    },
                    "caption": "Interior detail",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7be25bd0_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7be25bd0_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7be25bd0_z.jpg"
                    },
                    "id": "19904258:79"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/94abd332_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/94abd332_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/94abd332_z.jpg"
                    },
                    "id": "19904258:38"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4450adc3_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4450adc3_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4450adc3_z.jpg"
                    },
                    "id": "19904258:37"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 42,
                        "name": "Bathroom"
                    },
                    "caption": "Bathroom",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/998c5764_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/998c5764_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/998c5764_z.jpg"
                    },
                    "id": "19904258:29"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 24,
                        "name": "View from Room"
                    },
                    "caption": "View from room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/96b10409_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/96b10409_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/96b10409_z.jpg"
                    },
                    "id": "19904258:28"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 162,
                        "name": "Cafe"
                    },
                    "caption": "Cafe",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/41c8b262_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/41c8b262_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/41c8b262_z.jpg"
                    },
                    "id": "19904258:61"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 162,
                        "name": "Cafe"
                    },
                    "caption": "Cafe",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/41a3ecf7_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/41a3ecf7_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/41a3ecf7_z.jpg"
                    },
                    "id": "19904258:60"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 168,
                        "name": "Food and Drink"
                    },
                    "caption": "Food and drink",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42d7b916_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42d7b916_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/42d7b916_z.jpg"
                    },
                    "id": "19904258:63"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 168,
                        "name": "Food and Drink"
                    },
                    "caption": "Food and drink",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/28dea2e8_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/28dea2e8_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/28dea2e8_z.jpg"
                    },
                    "id": "19904258:62"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/61fd0d24_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/61fd0d24_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/61fd0d24_z.jpg"
                    },
                    "id": "19904258:21"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 186,
                        "name": "Hallway"
                    },
                    "caption": "Hallway",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1a98d8d5_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1a98d8d5_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1a98d8d5_z.jpg"
                    },
                    "id": "19904258:65"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0116b251_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0116b251_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0116b251_z.jpg"
                    },
                    "id": "19904258:20"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 186,
                        "name": "Hallway"
                    },
                    "caption": "Hallway",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f7d1742f_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f7d1742f_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f7d1742f_z.jpg"
                    },
                    "id": "19904258:64"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5153f564_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5153f564_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5153f564_z.jpg"
                    },
                    "id": "19904258:23"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 186,
                        "name": "Hallway"
                    },
                    "caption": "Hallway",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/d55835ee_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/d55835ee_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/d55835ee_z.jpg"
                    },
                    "id": "19904258:67"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7e324022_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7e324022_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7e324022_z.jpg"
                    },
                    "id": "19904258:22"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 186,
                        "name": "Hallway"
                    },
                    "caption": "Hallway",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4b0e32f1_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4b0e32f1_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4b0e32f1_z.jpg"
                    },
                    "id": "19904258:66"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 20,
                        "name": "Room Amenity"
                    },
                    "caption": "Room amenity",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/93af255d_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/93af255d_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/93af255d_z.jpg"
                    },
                    "id": "19904258:25"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 186,
                        "name": "Hallway"
                    },
                    "caption": "Hallway",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/50dc65da_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/50dc65da_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/50dc65da_z.jpg"
                    },
                    "id": "19904258:69"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 20,
                        "name": "Room Amenity"
                    },
                    "caption": "Room amenity",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0c753d2b_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0c753d2b_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0c753d2b_z.jpg"
                    },
                    "id": "19904258:24"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 186,
                        "name": "Hallway"
                    },
                    "caption": "Hallway",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/04343fe2_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/04343fe2_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/04343fe2_z.jpg"
                    },
                    "id": "19904258:68"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 24,
                        "name": "View from Room"
                    },
                    "caption": "View from room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/591a6d5d_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/591a6d5d_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/591a6d5d_z.jpg"
                    },
                    "id": "19904258:27"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 20,
                        "name": "Room Amenity"
                    },
                    "caption": "Room amenity",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/012876ff_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/012876ff_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/012876ff_z.jpg"
                    },
                    "id": "19904258:26"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/aba02693_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/aba02693_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/aba02693_z.jpg"
                    },
                    "id": "19904258:9"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b11018a7_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b11018a7_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b11018a7_z.jpg"
                    },
                    "id": "19904258:18"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b5689ef9_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b5689ef9_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/b5689ef9_z.jpg"
                    },
                    "id": "19904258:8"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/eb9b86f8_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/eb9b86f8_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/eb9b86f8_z.jpg"
                    },
                    "id": "19904258:17"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/6526ae1f_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/6526ae1f_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/6526ae1f_z.jpg"
                    },
                    "id": "19904258:7"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/8c91f854_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/8c91f854_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/8c91f854_z.jpg"
                    },
                    "id": "19904258:6"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e660cddf_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e660cddf_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e660cddf_z.jpg"
                    },
                    "id": "19904258:19"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7ee91ece_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7ee91ece_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/7ee91ece_z.jpg"
                    },
                    "id": "19904258:5"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/97322d77_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/97322d77_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/97322d77_z.jpg"
                    },
                    "id": "19904258:4"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cb335c8a_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cb335c8a_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cb335c8a_z.jpg"
                    },
                    "id": "19904258:3"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 5,
                        "name": "Lobby Sitting Area"
                    },
                    "caption": "Lobby sitting area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/603a9859_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/603a9859_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/603a9859_z.jpg"
                    },
                    "id": "19904258:2"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 5,
                        "name": "Lobby Sitting Area"
                    },
                    "caption": "Lobby sitting area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f3af994d_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f3af994d_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f3af994d_z.jpg"
                    },
                    "id": "19904258:1"
                },
                {
                    "hero_image": true,
                    "category": {
                        "id": 48,
                        "name": "Featured Image"
                    },
                    "caption": "Primary image",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a898e4ff_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a898e4ff_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a898e4ff_z.jpg"
                    },
                    "id": "19904258:0"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/d98244ed_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/d98244ed_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/d98244ed_z.jpg"
                    },
                    "id": "19904258:50"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 158,
                        "name": "Coffee Service"
                    },
                    "caption": "Coffee service",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/673680b2_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/673680b2_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/673680b2_z.jpg"
                    },
                    "id": "19904258:52"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a6bd7cb3_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a6bd7cb3_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a6bd7cb3_z.jpg"
                    },
                    "id": "19904258:51"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/159a232c_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/159a232c_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/159a232c_z.jpg"
                    },
                    "id": "19904258:10"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 160,
                        "name": "Buffet"
                    },
                    "caption": "Buffet",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/53fc12fb_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/53fc12fb_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/53fc12fb_z.jpg"
                    },
                    "id": "19904258:54"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 158,
                        "name": "Coffee Service"
                    },
                    "caption": "Coffee service",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/50ce2d97_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/50ce2d97_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/50ce2d97_z.jpg"
                    },
                    "id": "19904258:53"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a34193e5_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a34193e5_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a34193e5_z.jpg"
                    },
                    "id": "19904258:12"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 162,
                        "name": "Cafe"
                    },
                    "caption": "Cafe",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cddec87d_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cddec87d_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cddec87d_z.jpg"
                    },
                    "id": "19904258:56"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/dc376486_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/dc376486_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/dc376486_z.jpg"
                    },
                    "id": "19904258:11"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 160,
                        "name": "Buffet"
                    },
                    "caption": "Buffet",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e79bb8e8_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e79bb8e8_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e79bb8e8_z.jpg"
                    },
                    "id": "19904258:55"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0f9eca33_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0f9eca33_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0f9eca33_z.jpg"
                    },
                    "id": "19904258:14"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 162,
                        "name": "Cafe"
                    },
                    "caption": "Cafe",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1d8e5035_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1d8e5035_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/1d8e5035_z.jpg"
                    },
                    "id": "19904258:58"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4caa7393_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4caa7393_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/4caa7393_z.jpg"
                    },
                    "id": "19904258:13"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 162,
                        "name": "Cafe"
                    },
                    "caption": "Cafe",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3501bb93_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3501bb93_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3501bb93_z.jpg"
                    },
                    "id": "19904258:57"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/292d1f81_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/292d1f81_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/292d1f81_z.jpg"
                    },
                    "id": "19904258:16"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 9,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3fe04120_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3fe04120_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/3fe04120_z.jpg"
                    },
                    "id": "19904258:15"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 162,
                        "name": "Cafe"
                    },
                    "caption": "Cafe",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c20563ef_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c20563ef_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c20563ef_z.jpg"
                    },
                    "id": "19904258:59"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 196,
                        "name": "Front of Property"
                    },
                    "caption": "Front of property",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f96e5475_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f96e5475_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/f96e5475_z.jpg"
                    },
                    "id": "19904258:81"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 190,
                        "name": "Interior Detail"
                    },
                    "caption": "Interior detail",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e9d8c783_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e9d8c783_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/e9d8c783_z.jpg"
                    },
                    "id": "19904258:80"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 197,
                        "name": "Property Entrance"
                    },
                    "caption": "Property entrance",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/6e01411b_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/6e01411b_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/6e01411b_z.jpg"
                    },
                    "id": "19904258:83"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 196,
                        "name": "Front of Property"
                    },
                    "caption": "Front of property",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fd9956f7_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fd9956f7_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fd9956f7_z.jpg"
                    },
                    "id": "19904258:82"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/43a26e61_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/43a26e61_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/43a26e61_z.jpg"
                    },
                    "id": "19904258:41"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 198,
                        "name": "Front of Property - Evening/Night"
                    },
                    "caption": "Front of property - evening/night",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/21606e97_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/21606e97_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/21606e97_z.jpg"
                    },
                    "id": "19904258:85"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 46,
                        "name": "Bathroom Shower"
                    },
                    "caption": "Bathroom shower",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/86511785_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/86511785_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/86511785_z.jpg"
                    },
                    "id": "19904258:40"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 197,
                        "name": "Property Entrance"
                    },
                    "caption": "Property entrance",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fd060dc5_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fd060dc5_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/fd060dc5_z.jpg"
                    },
                    "id": "19904258:84"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/36c83812_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/36c83812_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/36c83812_z.jpg"
                    },
                    "id": "19904258:43"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 198,
                        "name": "Front of Property - Evening/Night"
                    },
                    "caption": "Front of property - evening/night",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0c9eb6fd_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0c9eb6fd_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0c9eb6fd_z.jpg"
                    },
                    "id": "19904258:87"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0355cd68_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0355cd68_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/0355cd68_z.jpg"
                    },
                    "id": "19904258:42"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 198,
                        "name": "Front of Property - Evening/Night"
                    },
                    "caption": "Front of property - evening/night",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/24741b30_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/24741b30_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/24741b30_z.jpg"
                    },
                    "id": "19904258:86"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cae99637_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cae99637_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/cae99637_z.jpg"
                    },
                    "id": "19904258:45"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 227,
                        "name": "View from Property"
                    },
                    "caption": "View from property",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a041a4d3_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a041a4d3_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a041a4d3_z.jpg"
                    },
                    "id": "19904258:89"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a373fd06_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a373fd06_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/a373fd06_z.jpg"
                    },
                    "id": "19904258:44"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 198,
                        "name": "Front of Property - Evening/Night"
                    },
                    "caption": "Front of property - evening/night",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5c8faccf_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5c8faccf_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5c8faccf_z.jpg"
                    },
                    "id": "19904258:88"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/352ceb80_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/352ceb80_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/352ceb80_z.jpg"
                    },
                    "id": "19904258:47"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c89a7077_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c89a7077_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/c89a7077_z.jpg"
                    },
                    "id": "19904258:46"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/758df570_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/758df570_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/758df570_z.jpg"
                    },
                    "id": "19904258:49"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 157,
                        "name": "Breakfast Area"
                    },
                    "caption": "Breakfast area",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/865980c3_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/865980c3_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/865980c3_z.jpg"
                    },
                    "id": "19904258:48"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 45,
                        "name": "Bathroom Sink"
                    },
                    "caption": "Bathroom sink",
                    "links": {
                        "70px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5506331b_t.jpg",
                        "350px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5506331b_b.jpg",
                        "1000px": "https://i.travelapi.com/hotels/20000000/19910000/19904300/19904258/5506331b_z.jpg"
                    },
                    "id": "19904258:39"
                }
            ]
        },
        "guest_rating": {
            "rating": "4.6",
            "count": 52,
            "cleanliness": "4.7",
            "service": "4.6",
            "comfort": "4.5",
            "condition": "4.5",
            "neighbourhood": "4.5",
            "amenities": "4.5"
        },
        "location": {
            "coordinates": {
                "latitude": 3.14411,
                "longitude": 101.698628
            }
        },
        "name": "Tian Jing Hotel",
        "star_rating": {
            "rating": "3.0",
            "type": "Star"
        },
        "checkin_details": {
            "time": "3:00 PM",
            "instructions": "<ul>  <li>Extra-person charges may apply and vary depending on property policy</li><li>Government-issued photo identification and a cash deposit may be required at check-in for incidental charges</li><li>Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed</li><li>Mobile payment options include: Alipay, Touch 'n Go eWallet, Boost, MaybankPay, GrabPay, and FavePay</li><li>Be prepared: check the latest COVID-19 travel requirements and measures in place for this destination before you travel.</li>  </ul>",
            "special_instructions": "To make arrangements for check-in please contact the property at least 24 hours before arrival using the information on the booking confirmation. Guests must contact the property in advance for check-in instructions. Front desk staff will greet guests on arrival."
        },
        "checkout_details": {
            "time": "11:00 AM"
        },
        "policies": {
            "know_before_you_go": "<ul>   <li>One child 5 years old or younger stays free when occupying the parent or guardian's room, using existing bedding. </li><li>Only registered guests are allowed in the guestrooms. </li> <li>No pets and no service animals are allowed at this property. </li><li>This property advises that enhanced cleaning and guest safety measures are currently in place.</li><li>Personal protective equipment, including masks, will be available to guests.</li><li>Social distancing measures are in place; staff at the property wear personal protective equipment; a shield is in place between staff and guests in main contact areas; periodic temperature checks are conducted on staff; temperature checks are available to guests; guests are provided with hand sanitizer; cashless payment methods are available for all transactions; masks are required in public areas.</li><li>Each guestroom is kept vacant for a minimum of 24 hours between bookings.</li> </ul>",
            "age_policy": {
                "min_adult_age": 18,
                "children_age_from": 5,
                "children_age_to": 17,
                "children_stay_free": false,
                "min_guest_age": 0
            }
        },
        "fees": {
            "mandatory": "<p>You'll be asked to pay the following charges at the property:</p> <ul><li>Cash deposit: MYR 100 per stay</li><li>A tax of MYR 10.00 per accommodation, per night is imposed by the country of Malaysia and collected at the property beginning January 1, 2023. Permanent residents and Malaysian nationals are exempt from the tax. For more details, please contact the property using the information on the reservation confirmation received after booking.</li></ul> <p>We have included all charges provided to us by the property. </p>",
            "optional": "<ul> <li>Fee for local cuisine breakfast: MYR 20 for adults and MYR 20 for children (approximately)</li>              <li>Early check-in fee: MYR 100 (subject to availability)</li>  <li>Late check-out fee: MYR 100</li>               </ul> <p>The above list may not be comprehensive. Fees and deposits may not include tax and are subject to change. </p>"
        },
        "spoken_languages": [
            {
                "id": 37,
                "name": "Malay"
            },
            {
                "id": 13,
                "name": "English"
            }
        ],
        "tax_id": "",
        "registration_number": "",
        "phone": "60-3-20221131",
        "fax": "60-3-20221137",
        "brand": {
            "id": 5696,
            "name": "Independent"
        },
        "chain": {
            "id": 5275,
            "name": "Independent"
        },
        "airports": {
            "nearest_airport": "KUL"
        },
        "headline": "In Kuala Lumpur (Golden Triangle)",
        "timezone": "Asia/Kuala_Lumpur",
        "need_nationality": false,
        "default_locale_used": false,
        "nearbyPoi": [
            {
                "name": "Petaling Street",
                "distance": "0.2 km / 0.1 mi"
            },
            {
                "name": "Petaling Street Market",
                "distance": "0.2 km / 0.1 mi"
            },
            {
                "name": "Central Market",
                "distance": "0.5 km / 0.3 mi"
            },
            {
                "name": "Merdeka 118",
                "distance": "0.5 km / 0.3 mi"
            },
            {
                "name": "Kottu Malai Pillayar Temple",
                "distance": "0.6 km / 0.3 mi"
            },
            {
                "name": "Jamek Mosque",
                "distance": "0.7 km / 0.4 mi"
            },
            {
                "name": "Kuala Lumpur Forest Eco Park",
                "distance": "0.9 km / 0.5 mi"
            },
            {
                "name": "Merdeka Square",
                "distance": "1 km / 0.6 mi"
            },
            {
                "name": "DBKL City Theatre",
                "distance": "1 km / 0.6 mi"
            },
            {
                "name": "Masjid India",
                "distance": "1.1 km / 0.7 mi"
            },
            {
                "name": "Mitsui Shopping Park LaLaport",
                "distance": "1.2 km / 0.8 mi"
            },
            {
                "name": "Kuala Lumpur Tower",
                "distance": "1.4 km / 0.9 mi"
            },
            {
                "name": "Jalan Alor",
                "distance": "1.4 km / 0.9 mi"
            },
            {
                "name": "Low Yat Plaza",
                "distance": "1.5 km / 1 mi"
            },
            {
                "name": "Changkat Bukit Bintang",
                "distance": "1.5 km / 1 mi"
            }
        ],
        "debug": {
            "aaid": "9868"
        }
    },
    {
        "aaHotelId": "c933",
        "property_type": {
            "id": 2,
            "name": "Hotel"
        },
        "address": {
            "city": "Kuala Lumpur",
            "country": "Malaysia",
            "country_code": "MY",
            "line_1": "227 Jalan Bukit Bintang",
            "line_2": "",
            "postal_code": "55100",
            "state_province_name": "Wilayah Persekutuan Kuala Lumpur"
        },
        "amenities": {
            "other_amenities": [],
            "top_amenities": [
                {
                    "id": 17,
                    "name": "24-hour front desk"
                },
                {
                    "id": 19,
                    "name": "Luggage storage"
                },
                {
                    "id": 22,
                    "name": "Concierge services"
                },
                {
                    "id": 18,
                    "name": "Dry cleaning/laundry service"
                },
                {
                    "id": 1,
                    "name": "Free Wifi"
                },
                {
                    "id": 8,
                    "name": "Smoke-free property"
                },
                {
                    "id": 2,
                    "name": "Pool"
                }
            ]
        },
        "description": {
            "amenities": "Enjoy recreation amenities such as an outdoor pool or take in the view from a terrace.",
            "attractions": "Distances are displayed to the nearest 0.1 mile and kilometer. <br /> <p>Pavilion Kuala Lumpur - 0.4 km / 0.2 mi <br /> Prince Court Medical Centre - 0.5 km / 0.3 mi <br /> Starhill Gallery - 0.6 km / 0.4 mi <br /> Fahrenheit 88 Shopping Mall - 0.7 km / 0.4 mi <br /> Lot 10 Shopping Centre - 0.8 km / 0.5 mi <br /> Changkat Bukit Bintang - 1 km / 0.6 mi <br /> Sungei Wang Plaza - 1 km / 0.6 mi <br /> Berjaya Times Square - 1.1 km / 0.7 mi <br /> Bukit Bintang Plaza - 1.1 km / 0.7 mi <br /> Low Yat Plaza - 1.2 km / 0.7 mi <br /> Kuala Lumpur Convention Centre - 1.2 km / 0.7 mi <br /> Jalan Alor - 1.3 km / 0.8 mi <br /> KLCC Park - 1.3 km / 0.8 mi <br /> Suria KLCC Shopping Centre - 1.5 km / 1 mi <br /> Mitsui Shopping Park LaLaport - 1.6 km / 1 mi <br /> </p><p>The nearest airports are:<br />Kuala Lumpur International Airport (KUL) - 57.7 km / 35.8 mi<br /> Subang (SZB-Sultan Abdul Aziz Shah) - 26.9 km / 16.7 mi<br /> </p><p></p>",
            "business_amenities": "Featured amenities include dry cleaning/laundry services, a 24-hour front desk, and multilingual staff. Self parking (subject to charges) is available onsite.",
            "dining": "You can enjoy a meal at Lucky serving the guests of Kloe Hotel, or stop in at the snack bar/deli. Cooked-to-order breakfasts are available daily from 7:00 AM to 10:00 AM for a fee.",
            "location": "With a stay at Kloe Hotel in Kuala Lumpur (Kampung Dollah), you'll be a 5-minute walk from Pavilion Kuala Lumpur and 13 minutes by foot from Berjaya Times Square.",
            "rooms": "Make yourself at home in one of the 85 air-conditioned rooms featuring minibars and Smart televisions. Complimentary wireless Internet access keeps you connected, and satellite programming is available for your entertainment. Private bathrooms have complimentary toiletries and bidets. Conveniences include phones, as well as safes and desks."
        },
        "gallery": {
            "images": [
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-04.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-04.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-04.jpg"
                    },
                    "id": "KE35357173DS:9"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-02.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-02.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-02.jpg"
                    },
                    "id": "KE35357173DS:8"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-01.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-01.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-01.jpg"
                    },
                    "id": "KE35357173DS:7"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-03.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-03.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-03.jpg"
                    },
                    "id": "KE35357173DS:6"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-01.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-01.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-01.jpg"
                    },
                    "id": "KE35357173DS:5"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/kloe%20Living%20Room%20Communal%20Table.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/kloe%20Living%20Room%20Communal%20Table.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/kloe%20Living%20Room%20Communal%20Table.jpg"
                    },
                    "id": "KE35357173DS:11"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-03.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-03.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-03.jpg"
                    },
                    "id": "KE35357173DS:4"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-05.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-05.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-05.jpg"
                    },
                    "id": "KE35357173DS:10"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-02.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-02.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Courtyard-02.jpg"
                    },
                    "id": "KE35357173DS:3"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Monroe_01.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Monroe_01.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Monroe_01.jpg"
                    },
                    "id": "KE35357173DS:2"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Lucky_01.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Lucky_01.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Lucky_01.jpg"
                    },
                    "id": "KE35357173DS:1"
                },
                {
                    "hero_image": true,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Pool_02.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Pool_02.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Pool_02.jpg"
                    },
                    "id": "KE35357173DS:0"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Kloe%20Living%20Room.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Kloe%20Living%20Room.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Kloe%20Living%20Room.jpg"
                    },
                    "id": "KE35357173DS:16"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-05.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-05.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-05.jpg"
                    },
                    "id": "KE35357173DS:13"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Kloe%20Pool.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Kloe%20Pool.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Kloe%20Pool.jpg"
                    },
                    "id": "KE35357173DS:12"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Pool_01.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Pool_01.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/Pool_01.jpg"
                    },
                    "id": "KE35357173DS:15"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-04.jpg",
                        "350px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-04.jpg",
                        "1000px": "https://a.staticaa.com/images/web-apps/hotel/dsimages/35357173/City-04.jpg"
                    },
                    "id": "KE35357173DS:14"
                }
            ]
        },
        "guest_rating": {
            "rating": "4.7",
            "count": 26,
            "cleanliness": "4.9",
            "service": "4.8",
            "comfort": "4.7",
            "condition": "4.8",
            "amenities": "4.8"
        },
        "location": {
            "coordinates": {
                "latitude": 3.147372,
                "longitude": 101.717927
            }
        },
        "name": "KLOE Hotel",
        "star_rating": {
            "rating": "3.0",
            "type": "Star"
        },
        "checkin_details": {
            "time": "3:00 PM",
            "instructions": "<ul>  <li>Extra-person charges may apply and vary depending on property policy</li><li>Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges</li><li>Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed</li><li>Safety features at this property include a fire extinguisher, a smoke detector, a first aid kit, and window guards</li><li>Be prepared: check the latest COVID-19 travel requirements and measures in place for this destination before you travel.</li>  </ul>",
            "special_instructions": "Front desk staff will greet guests on arrival."
        },
        "checkout_details": {
            "time": "12:00"
        },
        "policies": {
            "know_before_you_go": "<ul>  <li>Pool access available from 7:00 AM to 7:00 PM.</li><li>No pets and no service animals are allowed at this property. </li><li>This property advises that enhanced cleaning and guest safety measures are currently in place.</li><li>Disinfectant is used to clean the property, and commonly-touched surfaces are cleaned with disinfectant between stays.</li><li>Social distancing measures are in place; staff at the property wear personal protective equipment; guests are provided with hand sanitizer; cashless payment methods are available for all transactions; masks are required in public areas; reservations are required for some onsite facilities.</li><li>Enhanced food service safety measures are in place.</li><li>This property affirms that it adheres to the cleaning and disinfection practices of COVID-19 Guidelines (WHO).</li>\n </ul>",
            "age_policy": {
                "min_adult_age": 18,
                "children_age_from": 3,
                "children_age_to": 17,
                "children_stay_free": false,
                "min_guest_age": 0
            }
        },
        "fees": {
            "mandatory": "",
            "optional": ""
        },
        "spoken_languages": [
            {
                "id": 37,
                "name": "Malay"
            },
            {
                "id": 13,
                "name": "English"
            }
        ],
        "tax_id": "",
        "registration_number": "",
        "phone": "6-03-27721313",
        "fax": "",
        "brand": {
            "id": 5696,
            "name": "Independent"
        },
        "chain": {
            "id": 5275,
            "name": "Independent"
        },
        "headline": "Near Pavilion Kuala Lumpur",
        "timezone": "Asia/Kuala_Lumpur",
        "need_nationality": false,
        "default_locale_used": false,
        "nearbyPoi": [
            {
                "name": "Pavilion Kuala Lumpur",
                "distance": "0.4 km / 0.2 mi"
            },
            {
                "name": "Prince Court Medical Centre",
                "distance": "0.5 km / 0.3 mi"
            },
            {
                "name": "Starhill Gallery",
                "distance": "0.6 km / 0.4 mi"
            },
            {
                "name": "Fahrenheit 88 Shopping Mall",
                "distance": "0.7 km / 0.4 mi"
            },
            {
                "name": "Lot 10 Shopping Centre",
                "distance": "0.8 km / 0.5 mi"
            },
            {
                "name": "Changkat Bukit Bintang",
                "distance": "1 km / 0.6 mi"
            },
            {
                "name": "Sungei Wang Plaza",
                "distance": "1 km / 0.6 mi"
            },
            {
                "name": "Berjaya Times Square",
                "distance": "1.1 km / 0.7 mi"
            },
            {
                "name": "Bukit Bintang Plaza",
                "distance": "1.1 km / 0.7 mi"
            },
            {
                "name": "Low Yat Plaza",
                "distance": "1.2 km / 0.7 mi"
            },
            {
                "name": "Kuala Lumpur Convention Centre",
                "distance": "1.2 km / 0.7 mi"
            },
            {
                "name": "Jalan Alor",
                "distance": "1.3 km / 0.8 mi"
            },
            {
                "name": "KLCC Park",
                "distance": "1.3 km / 0.8 mi"
            },
            {
                "name": "Suria KLCC Shopping Centre",
                "distance": "1.5 km / 1 mi"
            },
            {
                "name": "Mitsui Shopping Park LaLaport",
                "distance": "1.6 km / 1 mi"
            }
        ],
        "debug": {
            "aaid": "c933"
        }
    },
    {
        "aaHotelId": "b829",
        "property_type": {
            "id": 2,
            "name": "Hotel"
        },
        "address": {
            "city": "Kuala Lumpur",
            "country": "Malaysia",
            "country_code": "MY",
            "line_1": "1012 Jalan Sultan Ismail",
            "line_2": "",
            "postal_code": "50100",
            "state_province_name": "KL"
        },
        "amenities": {
            "other_amenities": [],
            "top_amenities": [
                {
                    "id": 17,
                    "name": "24-hour front desk"
                },
                {
                    "id": 19,
                    "name": "Luggage storage"
                },
                {
                    "id": 1,
                    "name": "Free Wifi"
                },
                {
                    "id": 8,
                    "name": "Smoke-free property"
                }
            ]
        },
        "description": {
            "attractions": "Distances are displayed to the nearest 0.1 mile and kilometer. <br /> <p>Maju Junction Mall - 0.2 km / 0.1 mi <br /> SOGO - 0.4 km / 0.3 mi <br /> Chow Kit Night Market - 0.8 km / 0.5 mi <br /> Kuala Lumpur Forest Eco Park - 1 km / 0.6 mi <br /> Masjid Jamek Kampung Bahru Mosque - 1.1 km / 0.7 mi <br /> Masjid India - 1.1 km / 0.7 mi <br /> Sunway Putra Mall - 1.2 km / 0.8 mi <br /> DBKL City Theatre - 1.2 km / 0.8 mi <br /> World Trade Centre Kuala Lumpur - 1.4 km / 0.8 mi <br /> Merdeka Square - 1.5 km / 0.9 mi <br /> Jamek Mosque - 1.6 km / 1 mi <br /> Petronas Twin Towers - 1.9 km / 1.2 mi <br /> Central Market - 1.9 km / 1.2 mi <br /> Suria KLCC Shopping Centre - 2 km / 1.2 mi <br /> Petaling Street Market - 2 km / 1.3 mi <br /> </p><p>The nearest airports are:<br />Kuala Lumpur International Airport (KUL) - 60.2 km / 37.4 mi<br /> Subang (SZB-Sultan Abdul Aziz Shah) - 29.5 km / 18.3 mi<br /> </p><p></p>",
            "business_amenities": "Featured amenities include a 24-hour front desk, multilingual staff, and luggage storage. This hotel has 3 meeting rooms available for events. Self parking (subject to charges) is available onsite.",
            "dining": "Satisfy your appetite for lunch or dinner at The Chow Kit Kitchen, a restaurant which specializes in international cuisine, or stay in and take advantage of the room service (during limited hours). Wrap up your day with a drink at the bar/lounge. Cooked-to-order breakfasts are served on weekdays from 6:30 AM to 10:00 AM for a fee.",
            "location": "A stay at The Chow Kit - an Ormond Hotel places you in the heart of Kuala Lumpur, a 3-minute drive from Petronas Twin Towers and 6 minutes from SOGO.  This 4-star hotel is 1.4 mi (2.2 km) from Pavilion Kuala Lumpur and 1.7 mi (2.7 km) from Kuala Lumpur Tower.",
            "rooms": "Make yourself at home in one of the 113 air-conditioned rooms featuring Smart televisions. Complimentary wireless Internet access keeps you connected, and satellite programming is available for your entertainment. Private bathrooms with showers feature rainfall showerheads and complimentary toiletries. Conveniences include phones, as well as safes and complimentary bottled water."
        },
        "gallery": {
            "images": [
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/f7f9e708-6122-4086-82f2-dad1a3b4690f.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/f7f9e708-6122-4086-82f2-dad1a3b4690f.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/f7f9e708-6122-4086-82f2-dad1a3b4690f.jpg"
                    },
                    "id": "4568664:144"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6167,
                        "name": "General view"
                    },
                    "caption": "General view",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_007.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_007.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_007.jpg"
                    },
                    "id": "4568664:55"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/6c587c7f-8304-4b17-8828-109c25f32d2b.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/6c587c7f-8304-4b17-8828-109c25f32d2b.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/6c587c7f-8304-4b17-8828-109c25f32d2b.jpg"
                    },
                    "id": "4568664:145"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_006.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_006.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_006.jpg"
                    },
                    "id": "4568664:54"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/bd5a429f-4b7b-4389-b2af-b8a0f778ec75.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/bd5a429f-4b7b-4389-b2af-b8a0f778ec75.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/bd5a429f-4b7b-4389-b2af-b8a0f778ec75.jpg"
                    },
                    "id": "4568664:146"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_007.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_007.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_007.jpg"
                    },
                    "id": "4568664:57"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/2a99343f-a59a-4068-b914-219786e73725.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/2a99343f-a59a-4068-b914-219786e73725.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/2a99343f-a59a-4068-b914-219786e73725.jpg"
                    },
                    "id": "4568664:147"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_007.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_007.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_007.jpg"
                    },
                    "id": "4568664:56"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/06a8d285-8ac4-4913-80ff-b8d703dfb9df.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/06a8d285-8ac4-4913-80ff-b8d703dfb9df.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/06a8d285-8ac4-4913-80ff-b8d703dfb9df.jpg"
                    },
                    "id": "4568664:148"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_008.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_008.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_008.jpg"
                    },
                    "id": "4568664:59"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/03df18fc-7946-46e3-ac73-e9da432f08b3.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/03df18fc-7946-46e3-ac73-e9da432f08b3.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/03df18fc-7946-46e3-ac73-e9da432f08b3.jpg"
                    },
                    "id": "4568664:149"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_007.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_007.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_007.jpg"
                    },
                    "id": "4568664:58"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/3765a6b0-f73a-4e65-bc19-046c905f8c49.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/3765a6b0-f73a-4e65-bc19-046c905f8c49.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/3765a6b0-f73a-4e65-bc19-046c905f8c49.jpg"
                    },
                    "id": "4568664:140"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_006.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_006.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_006.jpg"
                    },
                    "id": "4568664:51"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/e099e2fb-242a-4b68-a624-b8b8e4bf5cfe.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/e099e2fb-242a-4b68-a624-b8b8e4bf5cfe.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/e099e2fb-242a-4b68-a624-b8b8e4bf5cfe.jpg"
                    },
                    "id": "4568664:141"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_006.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_006.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_006.jpg"
                    },
                    "id": "4568664:50"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/6d950833-7941-46b2-ac85-17c51fb26ea8.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/6d950833-7941-46b2-ac85-17c51fb26ea8.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/6d950833-7941-46b2-ac85-17c51fb26ea8.jpg"
                    },
                    "id": "4568664:142"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6167,
                        "name": "General view"
                    },
                    "caption": "General view",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_006.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_006.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_006.jpg"
                    },
                    "id": "4568664:53"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7785fb40-3ceb-41a0-8d83-925c4d928943.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7785fb40-3ceb-41a0-8d83-925c4d928943.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7785fb40-3ceb-41a0-8d83-925c4d928943.jpg"
                    },
                    "id": "4568664:143"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_006.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_006.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_006.jpg"
                    },
                    "id": "4568664:52"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/233dc2b6-67ab-49ec-9c3b-6e4dc392b4bc.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/233dc2b6-67ab-49ec-9c3b-6e4dc392b4bc.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/233dc2b6-67ab-49ec-9c3b-6e4dc392b4bc.jpg"
                    },
                    "id": "4568664:155"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_004.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_004.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_004.jpg"
                    },
                    "id": "4568664:44"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/4673d912-cfdd-455a-980b-ef71c3c730ac.png",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/4673d912-cfdd-455a-980b-ef71c3c730ac.png",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/4673d912-cfdd-455a-980b-ef71c3c730ac.png"
                    },
                    "id": "4568664:156"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_004.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_004.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_004.jpg"
                    },
                    "id": "4568664:43"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7b74cc33-d282-488d-b884-3824659cd537.png",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7b74cc33-d282-488d-b884-3824659cd537.png",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7b74cc33-d282-488d-b884-3824659cd537.png"
                    },
                    "id": "4568664:157"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_005.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_005.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_005.jpg"
                    },
                    "id": "4568664:46"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_005.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_005.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_005.jpg"
                    },
                    "id": "4568664:45"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_005.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_005.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_005.jpg"
                    },
                    "id": "4568664:48"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_005.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_005.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_005.jpg"
                    },
                    "id": "4568664:47"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6167,
                        "name": "General view"
                    },
                    "caption": "General view",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_005.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_005.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_005.jpg"
                    },
                    "id": "4568664:49"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/0CGkwJoD_5c258c2363d05e3d617276cc9473bad2.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/0CGkwJoD_5c258c2363d05e3d617276cc9473bad2.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/0CGkwJoD_5c258c2363d05e3d617276cc9473bad2.jpg"
                    },
                    "id": "4568664:9"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7a69c09d-a89b-470d-89e5-09421f50c2c8.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7a69c09d-a89b-470d-89e5-09421f50c2c8.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7a69c09d-a89b-470d-89e5-09421f50c2c8.jpg"
                    },
                    "id": "4568664:150"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/41a52471-ea34-4a8f-a45f-2004f8c6dd24.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/41a52471-ea34-4a8f-a45f-2004f8c6dd24.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/41a52471-ea34-4a8f-a45f-2004f8c6dd24.jpg"
                    },
                    "id": "4568664:151"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_004.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_004.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_004.jpg"
                    },
                    "id": "4568664:40"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/63326080-c971-459c-b882-f784fad1ee4b.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/63326080-c971-459c-b882-f784fad1ee4b.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/63326080-c971-459c-b882-f784fad1ee4b.jpg"
                    },
                    "id": "4568664:152"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/71f92ea2-5c9f-4ead-a3bc-b99924a549fb.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/71f92ea2-5c9f-4ead-a3bc-b99924a549fb.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/71f92ea2-5c9f-4ead-a3bc-b99924a549fb.jpg"
                    },
                    "id": "4568664:153"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6167,
                        "name": "General view"
                    },
                    "caption": "General view",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_004.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_004.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_004.jpg"
                    },
                    "id": "4568664:42"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/af21a21e-7284-4099-95c3-594e607b1c9c.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/af21a21e-7284-4099-95c3-594e607b1c9c.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/af21a21e-7284-4099-95c3-594e607b1c9c.jpg"
                    },
                    "id": "4568664:154"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_004.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_004.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_004.jpg"
                    },
                    "id": "4568664:41"
                },
                {
                    "hero_image": true,
                    "category": {
                        "id": 4992,
                        "name": "346 KB"
                    },
                    "caption": "346 KB",
                    "links": {
                        "70px": "https://hms-static.airasia.com//uploadfiles/m-637984965407703322TCK%20OTA super latest greatest.jpg",
                        "350px": "https://hms-static.airasia.com//uploadfiles/m-637984965407703322TCK%20OTA super latest greatest.jpg",
                        "1000px": "https://hms-static.airasia.com//uploadfiles/m-637984965407703322TCK%20OTA super latest greatest.jpg"
                    },
                    "id": "4568664:0"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/llbK3k4H_6e885fc9bb61346388cb1302bd4e8504.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/llbK3k4H_6e885fc9bb61346388cb1302bd4e8504.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/llbK3k4H_6e885fc9bb61346388cb1302bd4e8504.jpg"
                    },
                    "id": "4568664:8"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 247,
                        "name": "Lobby"
                    },
                    "caption": "Lobby",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/5TVTLv79_98b26533415cab302bdf63ef19102c38.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/5TVTLv79_98b26533415cab302bdf63ef19102c38.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/5TVTLv79_98b26533415cab302bdf63ef19102c38.jpg"
                    },
                    "id": "4568664:7"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 306,
                        "name": "Exterior"
                    },
                    "caption": "Exterior",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/TQhpEJ71_a6b8d7b9ebf2b9b0ae18e7bed2cb0946.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/TQhpEJ71_a6b8d7b9ebf2b9b0ae18e7bed2cb0946.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/TQhpEJ71_a6b8d7b9ebf2b9b0ae18e7bed2cb0946.jpg"
                    },
                    "id": "4568664:6"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/xok7A6vR_d002373bef9c08a0913d529fa20ab0b3.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/xok7A6vR_d002373bef9c08a0913d529fa20ab0b3.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/xok7A6vR_d002373bef9c08a0913d529fa20ab0b3.jpg"
                    },
                    "id": "4568664:5"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 3823,
                        "name": "105 KB"
                    },
                    "caption": "105 KB",
                    "links": {
                        "70px": "https://hms-static.airasia.com//uploadfiles/m-637987378072768545TCK%20AAcom Latest2.jpg",
                        "350px": "https://hms-static.airasia.com//uploadfiles/m-637987378072768545TCK%20AAcom Latest2.jpg",
                        "1000px": "https://hms-static.airasia.com//uploadfiles/m-637987378072768545TCK%20AAcom Latest2.jpg"
                    },
                    "id": "4568664:4"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 4259,
                        "name": "229 KB"
                    },
                    "caption": "229 KB",
                    "links": {
                        "70px": "https://hms-static.airasia.com//uploadfiles/m-637986481721732949AA%20main photo - 1.JPG",
                        "350px": "https://hms-static.airasia.com//uploadfiles/m-637986481721732949AA%20main photo - 1.JPG",
                        "1000px": "https://hms-static.airasia.com//uploadfiles/m-637986481721732949AA%20main photo - 1.JPG"
                    },
                    "id": "4568664:3"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 4135,
                        "name": "179 KB"
                    },
                    "caption": "179 KB",
                    "links": {
                        "70px": "https://hms-static.airasia.com//uploadfiles/m-637986481716420320AA%20main photo - 2.JPG",
                        "350px": "https://hms-static.airasia.com//uploadfiles/m-637986481716420320AA%20main photo - 2.JPG",
                        "1000px": "https://hms-static.airasia.com//uploadfiles/m-637986481716420320AA%20main photo - 2.JPG"
                    },
                    "id": "4568664:2"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 4268,
                        "name": "170 KB"
                    },
                    "caption": "170 KB",
                    "links": {
                        "70px": "https://hms-static.airasia.com//uploadfiles/m-637986480405820033AA%20Photo - Tony.JPG",
                        "350px": "https://hms-static.airasia.com//uploadfiles/m-637986480405820033AA%20Photo - Tony.JPG",
                        "1000px": "https://hms-static.airasia.com//uploadfiles/m-637986480405820033AA%20Photo - Tony.JPG"
                    },
                    "id": "4568664:1"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_013.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_013.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_013.jpg"
                    },
                    "id": "4568664:77"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_012.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_012.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_012.jpg"
                    },
                    "id": "4568664:76"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_013.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_013.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_013.jpg"
                    },
                    "id": "4568664:79"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_013.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_013.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_013.jpg"
                    },
                    "id": "4568664:78"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_011.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_011.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_011.jpg"
                    },
                    "id": "4568664:71"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_011.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_011.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_011.jpg"
                    },
                    "id": "4568664:70"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_012.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_012.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_012.jpg"
                    },
                    "id": "4568664:73"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_011.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_011.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_011.jpg"
                    },
                    "id": "4568664:72"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_012.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_012.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_012.jpg"
                    },
                    "id": "4568664:75"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_012.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_012.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_012.jpg"
                    },
                    "id": "4568664:74"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_010.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_010.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_010.jpg"
                    },
                    "id": "4568664:66"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6167,
                        "name": "General view"
                    },
                    "caption": "General view",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_010.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_010.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_010.jpg"
                    },
                    "id": "4568664:65"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_010.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_010.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_010.jpg"
                    },
                    "id": "4568664:68"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_010.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_010.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_010.jpg"
                    },
                    "id": "4568664:67"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_011.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_011.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_011.jpg"
                    },
                    "id": "4568664:69"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_008.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_008.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_008.jpg"
                    },
                    "id": "4568664:60"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_009.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_009.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_009.jpg"
                    },
                    "id": "4568664:62"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_008.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_008.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_008.jpg"
                    },
                    "id": "4568664:61"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_009.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_009.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_009.jpg"
                    },
                    "id": "4568664:64"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_009.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_009.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_009.jpg"
                    },
                    "id": "4568664:63"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_041.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_041.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_041.jpg"
                    },
                    "id": "4568664:99"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_042.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_042.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_042.jpg"
                    },
                    "id": "4568664:100"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/8KhX2FAY_9a82d08758156e5e7ae10de6946b628d.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/8KhX2FAY_9a82d08758156e5e7ae10de6946b628d.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/8KhX2FAY_9a82d08758156e5e7ae10de6946b628d.jpg"
                    },
                    "id": "4568664:11"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_040.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_040.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_040.jpg"
                    },
                    "id": "4568664:98"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_043.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_043.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_043.jpg"
                    },
                    "id": "4568664:101"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/dOZaoiVx_dec910e09f6ac2543d639ad302f7aa74.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/dOZaoiVx_dec910e09f6ac2543d639ad302f7aa74.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/dOZaoiVx_dec910e09f6ac2543d639ad302f7aa74.jpg"
                    },
                    "id": "4568664:10"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_044.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_044.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_044.jpg"
                    },
                    "id": "4568664:102"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/sf8kxmLc_46282c8f8d57a30033ec8b73470ee6c9.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/sf8kxmLc_46282c8f8d57a30033ec8b73470ee6c9.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/sf8kxmLc_46282c8f8d57a30033ec8b73470ee6c9.jpg"
                    },
                    "id": "4568664:13"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_045.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_045.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_045.jpg"
                    },
                    "id": "4568664:103"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/DlHI83g7_38c1a7c33f2afc63a14e4daa5106622a.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/DlHI83g7_38c1a7c33f2afc63a14e4daa5106622a.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/DlHI83g7_38c1a7c33f2afc63a14e4daa5106622a.jpg"
                    },
                    "id": "4568664:12"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_046.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_046.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_046.jpg"
                    },
                    "id": "4568664:104"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ZXMG3BBT_a21bfa23d4965e842c29ab059c3d2c99.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ZXMG3BBT_a21bfa23d4965e842c29ab059c3d2c99.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ZXMG3BBT_a21bfa23d4965e842c29ab059c3d2c99.jpg"
                    },
                    "id": "4568664:15"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_047.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_047.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_047.jpg"
                    },
                    "id": "4568664:105"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/delt1gBa_5f22fc4ceaba8e3a0e3b9e45c35b30b6.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/delt1gBa_5f22fc4ceaba8e3a0e3b9e45c35b30b6.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/delt1gBa_5f22fc4ceaba8e3a0e3b9e45c35b30b6.jpg"
                    },
                    "id": "4568664:14"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_048.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_048.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_048.jpg"
                    },
                    "id": "4568664:106"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ZI2rqka8_0a4b5c71fa90c937fcb1a9dade5e11a9.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ZI2rqka8_0a4b5c71fa90c937fcb1a9dade5e11a9.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ZI2rqka8_0a4b5c71fa90c937fcb1a9dade5e11a9.jpg"
                    },
                    "id": "4568664:17"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_049.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_049.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_049.jpg"
                    },
                    "id": "4568664:107"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/7PYSdZTj_29a790614075131c17c17f41763fe7ce.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/7PYSdZTj_29a790614075131c17c17f41763fe7ce.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/7PYSdZTj_29a790614075131c17c17f41763fe7ce.jpg"
                    },
                    "id": "4568664:16"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_025.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_025.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_025.jpg"
                    },
                    "id": "4568664:91"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_024.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_024.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_024.jpg"
                    },
                    "id": "4568664:90"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_035.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_035.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_035.jpg"
                    },
                    "id": "4568664:93"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_026.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_026.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_026.jpg"
                    },
                    "id": "4568664:92"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_037.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_037.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_037.jpg"
                    },
                    "id": "4568664:95"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_036.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_036.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_036.jpg"
                    },
                    "id": "4568664:94"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_039.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_039.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_039.jpg"
                    },
                    "id": "4568664:97"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_038.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_038.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_038.jpg"
                    },
                    "id": "4568664:96"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_050.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_050.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_050.jpg"
                    },
                    "id": "4568664:108"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ILG0EaR4_8f05c372ee037ea09a3dfbb0a7421a24.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ILG0EaR4_8f05c372ee037ea09a3dfbb0a7421a24.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/ILG0EaR4_8f05c372ee037ea09a3dfbb0a7421a24.jpg"
                    },
                    "id": "4568664:19"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_051.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_051.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_051.jpg"
                    },
                    "id": "4568664:109"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6164,
                        "name": "Hotel Rooms"
                    },
                    "caption": "Hotel Rooms",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/gaxR5wTB_b309b0eb633274b9c614011ac68680a7.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/gaxR5wTB_b309b0eb633274b9c614011ac68680a7.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/gaxR5wTB_b309b0eb633274b9c614011ac68680a7.jpg"
                    },
                    "id": "4568664:18"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_022.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_022.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_022.jpg"
                    },
                    "id": "4568664:88"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_053.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_053.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_053.jpg"
                    },
                    "id": "4568664:111"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_021.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_021.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_021.jpg"
                    },
                    "id": "4568664:87"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_054.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_054.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_054.jpg"
                    },
                    "id": "4568664:112"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_055.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_055.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_055.jpg"
                    },
                    "id": "4568664:113"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_023.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_023.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_023.jpg"
                    },
                    "id": "4568664:89"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_056.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_056.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_056.jpg"
                    },
                    "id": "4568664:114"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_057.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_057.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_057.jpg"
                    },
                    "id": "4568664:115"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_058.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_058.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_058.jpg"
                    },
                    "id": "4568664:116"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_059.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_059.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_059.jpg"
                    },
                    "id": "4568664:117"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_060.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_060.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_060.jpg"
                    },
                    "id": "4568664:118"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_014.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_014.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_014.jpg"
                    },
                    "id": "4568664:80"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_016.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_016.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_016.jpg"
                    },
                    "id": "4568664:82"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_015.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_015.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_015.jpg"
                    },
                    "id": "4568664:81"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_018.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_018.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_018.jpg"
                    },
                    "id": "4568664:84"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_017.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_017.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_017.jpg"
                    },
                    "id": "4568664:83"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_020.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_020.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_020.jpg"
                    },
                    "id": "4568664:86"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_019.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_019.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_019.jpg"
                    },
                    "id": "4568664:85"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_052.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_052.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_052.jpg"
                    },
                    "id": "4568664:110"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_061.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_061.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_061.jpg"
                    },
                    "id": "4568664:119"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_064.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_064.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_064.jpg"
                    },
                    "id": "4568664:122"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_002.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_002.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_002.jpg"
                    },
                    "id": "4568664:33"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_065.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_065.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_065.jpg"
                    },
                    "id": "4568664:123"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6167,
                        "name": "General view"
                    },
                    "caption": "General view",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_002.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_002.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_002.jpg"
                    },
                    "id": "4568664:32"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_066.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_066.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_066.jpg"
                    },
                    "id": "4568664:124"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 247,
                        "name": "Lobby"
                    },
                    "caption": "Lobby",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_002.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_002.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_002.jpg"
                    },
                    "id": "4568664:35"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_067.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_067.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_067.jpg"
                    },
                    "id": "4568664:125"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_002.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_002.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_002.jpg"
                    },
                    "id": "4568664:34"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_068.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_068.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_068.jpg"
                    },
                    "id": "4568664:126"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_003.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_003.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_003.jpg"
                    },
                    "id": "4568664:37"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7ae57f7a-439e-4680-a7c1-b8aeec9748fc.png",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7ae57f7a-439e-4680-a7c1-b8aeec9748fc.png",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/7ae57f7a-439e-4680-a7c1-b8aeec9748fc.png"
                    },
                    "id": "4568664:127"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_003.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_003.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_003.jpg"
                    },
                    "id": "4568664:36"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/28a1a992-c3a6-4be8-b78b-ed65ad683898.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/28a1a992-c3a6-4be8-b78b-ed65ad683898.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/28a1a992-c3a6-4be8-b78b-ed65ad683898.jpg"
                    },
                    "id": "4568664:128"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_003.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_003.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_003.jpg"
                    },
                    "id": "4568664:39"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/ab12efca-2521-4c4f-9bb2-405df6cbf18d.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/ab12efca-2521-4c4f-9bb2-405df6cbf18d.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/ab12efca-2521-4c4f-9bb2-405df6cbf18d.jpg"
                    },
                    "id": "4568664:129"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 247,
                        "name": "Lobby"
                    },
                    "caption": "Lobby",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_003.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_003.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_003.jpg"
                    },
                    "id": "4568664:38"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_062.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_062.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_062.jpg"
                    },
                    "id": "4568664:120"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_002.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_002.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_002.jpg"
                    },
                    "id": "4568664:31"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_063.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_063.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ro_063.jpg"
                    },
                    "id": "4568664:121"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 260,
                        "name": "Restaurant"
                    },
                    "caption": "Restaurant",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_001.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_001.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_r_001.jpg"
                    },
                    "id": "4568664:30"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/868e15d3-337f-4a4a-b032-b50cc5e41a65.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/868e15d3-337f-4a4a-b032-b50cc5e41a65.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/868e15d3-337f-4a4a-b032-b50cc5e41a65.jpg"
                    },
                    "id": "4568664:133"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6165,
                        "name": "Amenities and Services"
                    },
                    "caption": "Amenities and Services",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/HrC3U59v_ba1b011abe5d01806952f54e2875a027.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/HrC3U59v_ba1b011abe5d01806952f54e2875a027.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/HrC3U59v_ba1b011abe5d01806952f54e2875a027.jpg"
                    },
                    "id": "4568664:22"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/314e7cea-cf21-4638-b6a5-20836b82621c.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/314e7cea-cf21-4638-b6a5-20836b82621c.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/314e7cea-cf21-4638-b6a5-20836b82621c.jpg"
                    },
                    "id": "4568664:134"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6165,
                        "name": "Amenities and Services"
                    },
                    "caption": "Amenities and Services",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/GAt1bXax_aa6a2cd0c5a036bc2a16790ed0c4d901.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/GAt1bXax_aa6a2cd0c5a036bc2a16790ed0c4d901.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/GAt1bXax_aa6a2cd0c5a036bc2a16790ed0c4d901.jpg"
                    },
                    "id": "4568664:21"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/51da784b-569b-418d-a4c6-2a92b4baacdb.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/51da784b-569b-418d-a4c6-2a92b4baacdb.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/51da784b-569b-418d-a4c6-2a92b4baacdb.jpg"
                    },
                    "id": "4568664:135"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6167,
                        "name": "General view"
                    },
                    "caption": "General view",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_001.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_001.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_a_001.jpg"
                    },
                    "id": "4568664:24"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/f210d0d4-08b4-409e-85d6-c7856f607168.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/f210d0d4-08b4-409e-85d6-c7856f607168.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/f210d0d4-08b4-409e-85d6-c7856f607168.jpg"
                    },
                    "id": "4568664:136"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6166,
                        "name": "Leisure and Sport Facilities"
                    },
                    "caption": "Leisure and Sport Facilities",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/2STDMWbT_9db66892ad7c6163ad7896073e1e2670.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/2STDMWbT_9db66892ad7c6163ad7896073e1e2670.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/2STDMWbT_9db66892ad7c6163ad7896073e1e2670.jpg"
                    },
                    "id": "4568664:23"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/a0328208-a722-4237-a44d-4f824d1c4d1c.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/a0328208-a722-4237-a44d-4f824d1c4d1c.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/a0328208-a722-4237-a44d-4f824d1c4d1c.jpg"
                    },
                    "id": "4568664:137"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 250,
                        "name": "Room"
                    },
                    "caption": "Room",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_w_001.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_w_001.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_w_001.jpg"
                    },
                    "id": "4568664:26"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/8aa48979-2372-4360-9749-f450b252a5d9.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/8aa48979-2372-4360-9749-f450b252a5d9.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/8aa48979-2372-4360-9749-f450b252a5d9.jpg"
                    },
                    "id": "4568664:138"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 262,
                        "name": "Bar"
                    },
                    "caption": "Bar",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_001.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_001.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_ba_001.jpg"
                    },
                    "id": "4568664:25"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/05ff18f2-271f-4541-93ab-f73ef9f7e96c.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/05ff18f2-271f-4541-93ab-f73ef9f7e96c.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/05ff18f2-271f-4541-93ab-f73ef9f7e96c.jpg"
                    },
                    "id": "4568664:139"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6188,
                        "name": "Conferences"
                    },
                    "caption": "Conferences",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_001.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_001.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_k_001.jpg"
                    },
                    "id": "4568664:28"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 247,
                        "name": "Lobby"
                    },
                    "caption": "Lobby",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_001.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_001.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_l_001.jpg"
                    },
                    "id": "4568664:27"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/9e6da2b7-988a-493f-a48b-d97348510fb3.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/9e6da2b7-988a-493f-a48b-d97348510fb3.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/9e6da2b7-988a-493f-a48b-d97348510fb3.jpg"
                    },
                    "id": "4568664:130"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/40f0eccd-df39-4935-a814-918c80e82d41.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/40f0eccd-df39-4935-a814-918c80e82d41.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/40f0eccd-df39-4935-a814-918c80e82d41.jpg"
                    },
                    "id": "4568664:131"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6165,
                        "name": "Amenities and Services"
                    },
                    "caption": "Amenities and Services",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/2fUrjBEN_aeb6e2ad222e4a4370d97d24c9063ba1.png",
                        "350px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/2fUrjBEN_aeb6e2ad222e4a4370d97d24c9063ba1.png",
                        "1000px": "https://hotel-image-3rd.airasia.com/edotprod/poze_hotel/91/917995/2fUrjBEN_aeb6e2ad222e4a4370d97d24c9063ba1.png"
                    },
                    "id": "4568664:20"
                },
                {
                    "hero_image": false,
                    "caption": "",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/87b85ba3-7035-4f7b-80ba-ce4025de83df.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/87b85ba3-7035-4f7b-80ba-ce4025de83df.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/mgbb/PROD/MGDocuments/MY10002867/Photos/87b85ba3-7035-4f7b-80ba-ce4025de83df.jpg"
                    },
                    "id": "4568664:132"
                },
                {
                    "hero_image": false,
                    "category": {
                        "id": 6187,
                        "name": "Sports and Entertainment"
                    },
                    "caption": "Sports and Entertainment",
                    "links": {
                        "70px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_f_001.jpg",
                        "350px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_f_001.jpg",
                        "1000px": "https://hotel-image-3rd.airasia.com/ehb/giata/67/679147/679147a_hb_f_001.jpg"
                    },
                    "id": "4568664:29"
                }
            ]
        },
        "guest_rating": {
            "rating": "4.1",
            "count": 17,
            "cleanliness": "4.7",
            "service": "4.2",
            "comfort": "3.6",
            "condition": "4.4",
            "amenities": "3.5"
        },
        "location": {
            "coordinates": {
                "latitude": 3.160138,
                "longitude": 101.696664
            }
        },
        "name": "The Chow Kit - an Ormond Hotel (Malaysia's Leading Boutique Hotel)",
        "star_rating": {
            "rating": "4.0",
            "type": "Star"
        },
        "checkin_details": {
            "time": "2:00 PM",
            "instructions": "<ul>  <li>Extra-person charges may apply and vary depending on property policy</li><li>Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges</li><li>Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed</li><li>Safety features at this property include a fire extinguisher, a smoke detector, a security system, and a first aid kit</li><li>Be prepared: check the latest COVID-19 travel requirements and measures in place for this destination before you travel.</li>  </ul>",
            "special_instructions": "Front desk staff will greet guests on arrival."
        },
        "checkout_details": {
            "time": "12:00 PM"
        },
        "policies": {
            "know_before_you_go": "<ul>  <li>This property advises that enhanced cleaning and guest safety measures are currently in place.</li><li>Disinfectant is used to clean the property; commonly-touched surfaces are cleaned with disinfectant between stays; bed sheets and towels are laundered at a temperature of at least 60°C/140°F.</li><li>Personal protective equipment, including masks, will be available to guests.</li><li>Social distancing measures are in place; staff at the property wear personal protective equipment; periodic temperature checks are conducted on staff; temperature checks are available to guests; guests are provided with hand sanitizer.</li><li>Each guestroom is kept vacant for a minimum of 24 hours between bookings.</li><li>This property affirms that it follows the cleaning and disinfection practices of Safe & Clean (Malaysia).</li><li>This property affirms that it adheres to the cleaning and disinfection practices of Safe Travels (WTTC - Global).</li>\n </ul>",
            "age_policy": {
                "min_adult_age": 18,
                "children_age_from": 1,
                "children_age_to": 17,
                "children_stay_free": false,
                "min_guest_age": 0
            }
        },
        "fees": {
            "mandatory": "<p>You'll be asked to pay the following charges at the property:</p> <ul><li>Breakage deposit: MYR 100 per night</li><li>A tax of MYR 10.00 per accommodation, per night is imposed by the country of Malaysia and collected at the property beginning January 1, 2023. Permanent residents and Malaysian nationals are exempt from the tax. For more details, please contact the property using the information on the reservation confirmation received after booking.</li></ul> <p>We have included all charges provided to us by the property. </p>",
            "optional": "<ul> <li>Fee for cooked-to-order breakfast: MYR 35 for adults and MYR 35 for children (approximately)</li>        <li>Self parking fee: MYR 15 per day</li>        <li>Late check-out is available for a fee (subject to availability)</li>   <li>Rollaway bed fee: MYR 50 per night</li>            </ul> <p>The above list may not be comprehensive. Fees and deposits may not include tax and are subject to change. </p>"
        },
        "spoken_languages": [
            {
                "id": 37,
                "name": "Malay"
            },
            {
                "id": 13,
                "name": "English"
            }
        ],
        "tax_id": "",
        "registration_number": "",
        "phone": "60-327786666",
        "fax": "",
        "brand": {
            "id": 5696,
            "name": "Independent"
        },
        "chain": {
            "id": 5275,
            "name": "Independent"
        },
        "headline": "In Kuala Lumpur (Kuala Lumpur City Centre)",
        "timezone": "Asia/Kuala_Lumpur",
        "need_nationality": false,
        "default_locale_used": false,
        "nearbyPoi": [
            {
                "name": "Maju Junction Mall",
                "distance": "0.2 km / 0.1 mi"
            },
            {
                "name": "SOGO",
                "distance": "0.4 km / 0.3 mi"
            },
            {
                "name": "Chow Kit Night Market",
                "distance": "0.8 km / 0.5 mi"
            },
            {
                "name": "Kuala Lumpur Forest Eco Park",
                "distance": "1 km / 0.6 mi"
            },
            {
                "name": "Masjid Jamek Kampung Bahru Mosque",
                "distance": "1.1 km / 0.7 mi"
            },
            {
                "name": "Masjid India",
                "distance": "1.1 km / 0.7 mi"
            },
            {
                "name": "Sunway Putra Mall",
                "distance": "1.2 km / 0.8 mi"
            },
            {
                "name": "DBKL City Theatre",
                "distance": "1.2 km / 0.8 mi"
            },
            {
                "name": "World Trade Centre Kuala Lumpur",
                "distance": "1.4 km / 0.8 mi"
            },
            {
                "name": "Merdeka Square",
                "distance": "1.5 km / 0.9 mi"
            },
            {
                "name": "Jamek Mosque",
                "distance": "1.6 km / 1 mi"
            },
            {
                "name": "Petronas Twin Towers",
                "distance": "1.9 km / 1.2 mi"
            },
            {
                "name": "Central Market",
                "distance": "1.9 km / 1.2 mi"
            },
            {
                "name": "Suria KLCC Shopping Centre",
                "distance": "2 km / 1.2 mi"
            },
            {
                "name": "Petaling Street Market",
                "distance": "2 km / 1.3 mi"
            }
        ],
        "debug": {
            "aaid": "b829"
        }
    }
]

export const hotelSampleData = {
    "id": "b7ee3",
    "name": "The Kuala Lumpur Journal",
    "baseRate": {
      "currency": "USD",
      "value": "67"
    },
    "strikethroughPrice": {
      "currency": "USD",
      "value": "67"
    },
    "image": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Hero.jpg",
    "starRating": {
      "stars": 4,
      "text": "stars"
    },
    "debug": null,
    "guestRating": "4.4",
    "guestRatingLabelId": "4.0",
    "guestRatingCount": 993,
    "leftPillTexts": [
      "{translationId: \"tags.member_rate\", value: \"Member'…}"
    ],
    "discountType": null,
    "tags": {
      "left_view": "[{…}]"
    },
    "location": "Near Pavilion Kuala Lumpur",
    "recommended": 0,
    "bigPoint": {
      "points_earn": 933,
      "multiplier": "1.0"
    },
    "isPayAtHotel": true,
    "isCrossSellRate": false,
    "isHotelSelected": false,
    "images": [
      "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Hero.jpg",
      "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Dining4.JPG",
      "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Dining5.jpg",
      "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Aerial2.JPG",
      "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Amenities1.jpg"
    ],
    "coordinates": {
      "lat": "3.148078",
      "lon": "101.710445"
    },
    "isPayLater": false,
    "amenities": [
      {id: 17, name: "24-hour front desk"},
      {id: 19, name: "Luggage storage"},
      {id: 3, name: "Gym"},
      {id: 18, name: "Dry cleaning/laundry service"},
      {id: 1, name: "Free Wifi"},
      {id: 8, name: "Smoke-free property"}
    ],
    "focusHighLight": false,
    "highlight": false,
    "tripAdvisorReviews": null,
    "locale": "en-gb",
    "bigPointPromo": "Earn 2X 933 airasia points",
    "discountText": null,
    "heroImage": "https://static.airasia.com/hotels/web-apps/hotel/dsimages-350/13183369/Hero.jpg",
    "onLoadImage": "ƒ onLoadImage() {}",
    "hotelName": "The Kuala Lumpur Journal",
    "isImageCarouselEnabled": true,
    "promoTitle": null,
    "isMobile": false,
    "price": {
      "currency": "USD",
      "value": 67
    },
    "strikeThrough": {
      "currency": "USD",
      "value": "67"
    },
    "distance": null,
    "promoTag": "Member's Exclusive",
    "hilightText": "You searched for this hotel",
    "reviews": {
      "message": "Very Good!",
      "rating": "4.4",
      "reviewCount": 993
    },
    "snapPriceText": null,
    "translations": {
      "amenityTitle": "All hotel amenities",
      "freeCancellationText": null,
      "payLaterText": null,
      "payAtHotelText": "Pay at hotel",
      "priceText": "per room per night",
      "reviewTranslation": "reviews",
      "lowInventoryAlert": ""
    },
    "onClick": "ƒ () {}",
    "facilities": [],
    "certifiedSuperTitel": null,
    "isDoDEnabled": false,
    "time": "0:10:00",
    "DoDLableFirst": "Deal of the Day",
    "DoDLableSecond": "Expires in",
    "accessible": true,
    "salesTag": null,
    "priceText": null,
    "perGuestText": null,
    "theme": "AIRASIA_CLASSIC",
    "fomoLabel": null,
    "expandCarouselArrowClickableArea": false,
    "isFomoTimerEnabled": false,
    "isCarouselCard": false,
    "fomoTime": "",
    "gaIdExperimentValue": 1,
    "isComboSavingsTagEnabled": false,
    "savingsAmount": 0,
    "selectRoomLabel": "Select Room",
    "withSelectRoom": false
}

export const respData = {
    "aaHotelId": "275ea6",
    "property_type": {
        "id": 2,
        "name": "Hotel"
    },
    "address": {
        "city": "Melbourne",
        "country": "Australia",
        "country_code": "AU",
        "line_1": "99 Franklin St",
        "line_2": "",
        "postal_code": "3000",
        "state_province_name": "Victoria"
    },
    "amenities": {
        "other_amenities": [],
        "top_amenities": [
            {
                "id": 17,
                "name": "24-hour front desk"
            },
            {
                "id": 19,
                "name": "Luggage storage"
            },
            {
                "id": 22,
                "name": "Concierge services"
            },
            {
                "id": 18,
                "name": "Dry cleaning/laundry service"
            },
            {
                "id": 1,
                "name": "Free Wifi"
            },
            {
                "id": 8,
                "name": "Smoke-free property"
            }
        ]
    },
    "description": {
        "amenities": "Make use of convenient amenities, which include complimentary wireless Internet access and concierge services.",
        "attractions": "Distances are displayed to the nearest 0.1 mile and kilometer. <br /> <p>RMIT University - 0.2 km / 0.1 mi <br /> Melbourne Central - 0.3 km / 0.2 mi <br /> State Library of Victoria - 0.4 km / 0.3 mi <br /> Lygon Street - 0.5 km / 0.3 mi <br /> Queen Victoria Market - 0.5 km / 0.3 mi <br /> QV Centre - 0.5 km / 0.3 mi <br /> Old Melbourne Gaol - 0.5 km / 0.3 mi <br /> Hardware Lane - 0.6 km / 0.3 mi <br /> Flagstaff Gardens - 0.7 km / 0.4 mi <br /> Carlton Gardens - 0.8 km / 0.5 mi <br /> Bourke Street Mall - 0.9 km / 0.5 mi <br /> Collins Street - 1 km / 0.6 mi <br /> Her Majesty's Theatre - 1.1 km / 0.7 mi <br /> University of Melbourne - 1.1 km / 0.7 mi <br /> Peter MacCallum Cancer Centre - 1.1 km / 0.7 mi <br /> </p><p>The nearest airports are:<br />Melbourne Airport (MEL) - 21.3 km / 13.2 mi<br /> Melbourne, VIC (MEB-Essendon) - 14.3 km / 8.9 mi<br /> Avalon Airport (AVV) - 56.5 km / 35.1 mi<br /> </p><p></p>",
        "business_amenities": "Featured amenities include dry cleaning/laundry services, a 24-hour front desk, and luggage storage. Planning an event in Melbourne? This hotel has facilities measuring 1615 square feet (150 square meters), including conference space. A roundtrip airport shuttle is provided for a surcharge (available 24 hours).",
        "location": "Scape Living at Franklin is centrally located in Melbourne, a 4-minute walk from Melbourne Central and 6 minutes by foot from Queen Victoria Market.  This hotel is 0.9 mi (1.4 km) from Collins Street and 1.1 mi (1.7 km) from Princess Theatre.",
        "rooms": "Make yourself at home in one of the 127 individually decorated guestrooms, featuring kitchens with full-sized refrigerators/freezers and ovens. 43-inch Smart televisions with digital programming provide entertainment, while complimentary wireless Internet access keeps you connected. Conveniences include irons/ironing boards and blackout drapes/curtains, and housekeeping is provided on request."
    },
    "gallery": {
        "images": [
            {
                "hero_image": false,
                "category": {
                    "id": 174,
                    "name": "Lounge"
                },
                "caption": "Lounge",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/dfd8051d_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/dfd8051d_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/dfd8051d_z.jpg"
                },
                "id": "68501129:28"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 188,
                    "name": "Meeting Facility"
                },
                "caption": "Meeting facility",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/c8f6fb4d_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/c8f6fb4d_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/c8f6fb4d_z.jpg"
                },
                "id": "68501129:29"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 64,
                    "name": "Fitness Facility"
                },
                "caption": "Fitness facility",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8b764594_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8b764594_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8b764594_z.jpg"
                },
                "id": "68501129:24"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 67,
                    "name": "Fitness Studio"
                },
                "caption": "Fitness studio",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/4ed01c49_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/4ed01c49_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/4ed01c49_z.jpg"
                },
                "id": "68501129:25"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 132,
                    "name": "Property Amenity"
                },
                "caption": "Property amenity",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/bc643aa6_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/bc643aa6_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/bc643aa6_z.jpg"
                },
                "id": "68501129:26"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 174,
                    "name": "Lounge"
                },
                "caption": "Lounge",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/50368aa8_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/50368aa8_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/50368aa8_z.jpg"
                },
                "id": "68501129:27"
            },
            {
                "hero_image": false,
                "caption": "Dining room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/7926f820_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/7926f820_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/7926f820_z.jpg"
                },
                "id": "68501129:20"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 42,
                    "name": "Bathroom"
                },
                "caption": "Bathroom",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/02d5e631_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/02d5e631_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/02d5e631_z.jpg"
                },
                "id": "68501129:21"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 42,
                    "name": "Bathroom"
                },
                "caption": "Bathroom",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/07688c2d_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/07688c2d_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/07688c2d_z.jpg"
                },
                "id": "68501129:22"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 42,
                    "name": "Bathroom"
                },
                "caption": "Bathroom",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/cc844f7e_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/cc844f7e_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/cc844f7e_z.jpg"
                },
                "id": "68501129:23"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 9,
                    "name": "Room"
                },
                "caption": "Room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/abf02aa2_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/abf02aa2_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/abf02aa2_z.jpg"
                },
                "id": "68501129:5"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 9,
                    "name": "Room"
                },
                "caption": "Room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8a832221_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8a832221_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8a832221_z.jpg"
                },
                "id": "68501129:4"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 9,
                    "name": "Room"
                },
                "caption": "Room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8ea014c7_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8ea014c7_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/8ea014c7_z.jpg"
                },
                "id": "68501129:3"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 9,
                    "name": "Room"
                },
                "caption": "Room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/e7b22f32_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/e7b22f32_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/e7b22f32_z.jpg"
                },
                "id": "68501129:2"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 4,
                    "name": "Reception"
                },
                "caption": "Reception",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/5dce65ce_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/5dce65ce_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/5dce65ce_z.jpg"
                },
                "id": "68501129:1"
            },
            {
                "hero_image": true,
                "category": {
                    "id": 48,
                    "name": "Featured Image"
                },
                "caption": "Primary image",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/e6d7b75e_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/e6d7b75e_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/e6d7b75e_z.jpg"
                },
                "id": "68501129:0"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 24,
                    "name": "View from Room"
                },
                "caption": "View from room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/3b591d2f_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/3b591d2f_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/3b591d2f_z.jpg"
                },
                "id": "68501129:17"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 24,
                    "name": "View from Room"
                },
                "caption": "View from room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/61f4a899_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/61f4a899_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/61f4a899_z.jpg"
                },
                "id": "68501129:18"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 24,
                    "name": "View from Room"
                },
                "caption": "View from room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/1db61033_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/1db61033_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/1db61033_z.jpg"
                },
                "id": "68501129:19"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 13,
                    "name": "Private Kitchen"
                },
                "caption": "Private kitchen",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/96580742_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/96580742_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/96580742_z.jpg"
                },
                "id": "68501129:9"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 16,
                    "name": "Living Area"
                },
                "caption": "Living area",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/186d7836_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/186d7836_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/186d7836_z.jpg"
                },
                "id": "68501129:13"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 9,
                    "name": "Room"
                },
                "caption": "Room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/c6bf40b2_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/c6bf40b2_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/c6bf40b2_z.jpg"
                },
                "id": "68501129:8"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 16,
                    "name": "Living Area"
                },
                "caption": "Living area",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/72af8c01_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/72af8c01_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/72af8c01_z.jpg"
                },
                "id": "68501129:14"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 9,
                    "name": "Room"
                },
                "caption": "Room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/7bd78aaa_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/7bd78aaa_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/7bd78aaa_z.jpg"
                },
                "id": "68501129:7"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 16,
                    "name": "Living Area"
                },
                "caption": "Living area",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/41b939af_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/41b939af_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/41b939af_z.jpg"
                },
                "id": "68501129:15"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 9,
                    "name": "Room"
                },
                "caption": "Room",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/5775856d_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/5775856d_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/5775856d_z.jpg"
                },
                "id": "68501129:6"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 16,
                    "name": "Living Area"
                },
                "caption": "Living area",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/a79afb15_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/a79afb15_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/a79afb15_z.jpg"
                },
                "id": "68501129:16"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 16,
                    "name": "Living Area"
                },
                "caption": "Living area",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/ed2e5156_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/ed2e5156_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/ed2e5156_z.jpg"
                },
                "id": "68501129:10"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 16,
                    "name": "Living Area"
                },
                "caption": "Living area",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/6177310e_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/6177310e_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/6177310e_z.jpg"
                },
                "id": "68501129:11"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 16,
                    "name": "Living Area"
                },
                "caption": "Living area",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/da781664_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/da781664_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/da781664_z.jpg"
                },
                "id": "68501129:12"
            },
            {
                "hero_image": false,
                "category": {
                    "id": 218,
                    "name": "Exterior"
                },
                "caption": "Exterior",
                "links": {
                    "70px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/w8946h5449x0y0-5c0d92c0_t.jpg",
                    "350px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/w8946h5449x0y0-5c0d92c0_b.jpg",
                    "1000px": "https://i.travelapi.com/lodging/69000000/68510000/68501200/68501129/w8946h5449x0y0-5c0d92c0_z.jpg"
                },
                "id": "68501129:30"
            }
        ]
    },
    "guest_rating": {
        "rating": "4.8",
        "count": 163,
        "cleanliness": "4.8",
        "service": "4.8",
        "comfort": "4.7",
        "condition": "4.8",
        "amenities": "4.6"
    },
    "location": {
        "coordinates": {
            "latitude": -37.808141,
            "longitude": 144.961083
        }
    },
    "name": "Scape Living at Franklin",
    "star_rating": {
        "rating": "3.5",
        "type": "Star"
    },
    "checkin_details": {
        "time": "2:00 PM",
        "instructions": "<ul>  <li>Extra-person charges may apply and vary depending on property policy</li><li>Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges</li><li>Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed</li><li>Be prepared: check the latest COVID-19 travel requirements and measures in place for this destination before you travel.</li>  </ul>",
        "special_instructions": "This property offers transfers from the airport (surcharges may apply). Guests must contact the property with arrival details before travel, using the contact information on the booking confirmation. If you are planning to arrive after 10:00 PM please contact the property in advance using the information on the booking confirmation. Guests will receive an email 72 hours before arrival with check-in instructions. Front desk staff will greet guests on arrival."
    },
    "checkout_details": {
        "time": "11:00 AM"
    },
    "policies": {
        "know_before_you_go": "<ul>  <li>This property advises that enhanced cleaning and guest safety measures are currently in place.</li><li>Disinfectant is used to clean the property; commonly-touched surfaces are cleaned with disinfectant between stays; bed sheets and towels are laundered at a temperature of at least 60°C/140°F.</li><li>Social distancing measures are in place; guests are provided with hand sanitizer; cashless payment methods are available for all transactions.</li> </ul>",
        "age_policy": {
            "min_adult_age": 18,
            "children_age_from": 3,
            "children_age_to": 17,
            "children_stay_free": false,
            "min_guest_age": 0
        }
    },
    "fees": {
        "mandatory": "",
        "optional": "<ul>      <li>Airport shuttle fee: AUD 60 per person (one-way)</li> <li>Airport shuttle fee per child: AUD 0</li>    <li>Nearby parking fee: AUD 35 per day (82 ft away)</li>     <li>Late check-out is available for a fee (subject to availability)</li> <li>Weekly housekeeping provided; fees apply for additional cleaning</li>              </ul> <p>The above list may not be comprehensive. Fees and deposits may not include tax and are subject to change. </p>"
    },
    "spoken_languages": [
        {
            "id": 13,
            "name": "English"
        }
    ],
    "tax_id": "",
    "registration_number": "",
    "phone": "61-04-28192471",
    "fax": "",
    "brand": {
        "id": 5696,
        "name": "Independent"
    },
    "chain": {
        "id": 5275,
        "name": "Independent"
    },
    "airports": {
        "nearest_airport": "MEL"
    },
    "headline": "In Melbourne (Melbourne Central Business District)",
    "timezone": "Australia/Melbourne",
    "need_nationality": false,
    "default_locale_used": false,
    "nearbyPoi": [
        {
            "name": "RMIT University",
            "distance": "0.2 km / 0.1 mi"
        },
        {
            "name": "Melbourne Central",
            "distance": "0.3 km / 0.2 mi"
        },
        {
            "name": "State Library of Victoria",
            "distance": "0.4 km / 0.3 mi"
        },
        {
            "name": "Lygon Street",
            "distance": "0.5 km / 0.3 mi"
        },
        {
            "name": "Queen Victoria Market",
            "distance": "0.5 km / 0.3 mi"
        },
        {
            "name": "QV Centre",
            "distance": "0.5 km / 0.3 mi"
        },
        {
            "name": "Old Melbourne Gaol",
            "distance": "0.5 km / 0.3 mi"
        },
        {
            "name": "Hardware Lane",
            "distance": "0.6 km / 0.3 mi"
        },
        {
            "name": "Flagstaff Gardens",
            "distance": "0.7 km / 0.4 mi"
        },
        {
            "name": "Carlton Gardens",
            "distance": "0.8 km / 0.5 mi"
        },
        {
            "name": "Bourke Street Mall",
            "distance": "0.9 km / 0.5 mi"
        },
        {
            "name": "Collins Street",
            "distance": "1 km / 0.6 mi"
        },
        {
            "name": "Her Majesty's Theatre",
            "distance": "1.1 km / 0.7 mi"
        },
        {
            "name": "University of Melbourne",
            "distance": "1.1 km / 0.7 mi"
        },
        {
            "name": "Peter MacCallum Cancer Centre",
            "distance": "1.1 km / 0.7 mi"
        }
    ],
    "debug": {
        "aaid": "275ea6"
    }
}

export const transformRespToProps = (data, locale) => {
    return {
        ...data,
        id: _.get(data, "id", ""),
        name: _.get(data, "name", ""),
        baseRate: _.get(data, 'prices.rate.lead_price.base_rate', {currency: "MYR", value: ""}),
        strikethroughPrice: {currency: "MYR", value: ""},
        image: _.findLast(_.get(data, "gallery.images", []), x => _.get(x, "hero_image", false)),
        starRating: {text: "stars", stars: _.toInteger(_.get(data, "star_rating.rating", 1))},
        guestRating: _.get(data, "guest_rating.rating", "3.0"),
        guestRatingCount: _.get(data, "guest_rating.count", "0"),
        location: _.get(data, "headline", ""),
        debugObj: _.get(data, "debug", {}),
        debug: null,
        images: _.map(_.get(data, "gallery.images", []), x => _.last(_.values(_.get(x, "links", {})))),
        coordinates: {lat: _.toString(_.get(data, "location.lat", 0)), lon: _.toString(_.get(data, "location.lon", 0))},
        amenities: _.get(data, "prices.rate.amenities", []),
        locale,
        heroImage: _.findLast(_.get(data, "gallery.images", []), x => _.get(x, "hero_image", false)),
        hotelName: _.get(data, "name", ""),
        isImageCarouselEnabled: true,
        price: _.get(data, 'prices.rate.lead_price.base_rate', {currency: "MYR", value: ""}),
        strikeThrough: {currency: "MYR", value: ""},
        reviews: {message: "", rating:  _.get(data, "guest_rating.rating", "3.0"), reviewCount: _.get(data, "guest_rating.count", "0")},

    };
};

export const testDataFromresp = transformRespToProps(respData, "en-us");